//const aeskey = '4fa8959db7b4423a99f056e299914128';
//import { decrypt } from './cipher';
// import ViewModel from '../shell/viewmodel/viewmodel';
// let { getGlobalStorage } = ViewModel;
/**
* 为全局添加业务信息
* 如： 业务日期 业务集团信息 用户id
* businessDate 业务日期
* userId 用户id
* groupId 集团id
* @param {Object} config 
*/
export default function getBusinessInfo(config) {
    if (window.top && typeof window.top.GETBUSINESSINFO === 'function') {
        return window.top.GETBUSINESSINFO(config);
    }
    // } else {
    //     let businessInfo = {};
    //     //let STOREFORINFODATA = localStorage.getItem("STOREFORINFODATA");
    //     let STOREFORINFODATA = getGlobalStorage("localStorage","STOREFORINFODATA");
    //     if (STOREFORINFODATA) {
    //         //businessInfo = decrypt(STOREFORINFODATA, aeskey);
    //         businessInfo = STOREFORINFODATA && JSON.parse(STOREFORINFODATA);
    //         businessInfo.businessDate = businessInfo.bizDateTime
    //     }
    //     return businessInfo;
    // }
}